module.exports = __webpack_public_path__ + "public/img/Menghitung Gaji Bersih di Excel untuk HR.89d0108e.png";